import React from 'react';
import { Redirect } from 'react-router-dom';
//Page Alerts
import Alerts from '../pages/Alerts/Alerts';
import ForgetPwd from '../pages/Authentication/ForgetPassword';
// Authentication related pages
import Login from '../pages/Authentication/Login';
import Logout from '../pages/Authentication/Logout';
import Register from '../pages/Authentication/Register';
//Page Mapa
import MapPositions from '../pages/Map/MapPositions';
import NewParameter from '../pages/Parameters/NewParameter';
// Parameters
import Parameters from '../pages/Parameters/Parameters';
// RACKS
import Racks from '../pages/Racks/Racks';
import SettingsGlobal from '../pages/Settings/SettingsGlobal';
import DataRetentionPolicies from '../pages/Settings/DataRetentionPolicies';
import NewTask from '../pages/Tasks/NewTask';
import Tasks from '../pages/Tasks/Tasks';
//Page Tasks
import TasksDashboard from '../pages/Tasks/tasks-dashboard';
import TasksWorkStations from '../pages/Tasks/TasksWorkstations';
import UpdateTask from '../pages/Tasks/UpdateTask';
import NewUser from '../pages/Users/NewUser';
import UpdateUser from '../pages/Users/UpdateUser';
// Pages Users
import Users from '../pages/Users/Users';
import NewWorkstation from '../pages/Workstations/NewWorkstation';
import ProfileWorkstation from '../pages/Workstations/ProfileWorkstation';
import UpdateWorkstation from '../pages/Workstations/UpdateWorkstation';
// Pages Workstations
import Workstations from '../pages/Workstations/Workstations';
import WSPositions from '../pages/Workstations/WSPositions';
// DMX (AA-11839)
import DmxControllers from '../pages/Dmx/DmxControllers';
import NewDmxController from '../pages/Dmx/NewDmxController';
import DmxControllerDetails from '../pages/Dmx/DmxControllerDetails';
import DmxUniverseOccupancy from '../pages/Dmx/DmxUniverseOccupancy';
import NewDmxDevice from '../pages/Dmx/NewDmxDevice';
import DmxDeviceDetails from '../pages/Dmx/DmxDeviceDetails';
import DmxDeviceProfiles from '../pages/Dmx/DmxDeviceProfiles';
import NewDmxDeviceProfile from '../pages/Dmx/NewDmxDeviceProfile';
import DmxDeviceProfileDetails from '../pages/Dmx/DmxDeviceProfileDetails';
// PLC Safety (P01021-135)
import PlcSafetyCauses from '../pages/PlcSafety/PlcSafetyCauses';
import PlcSafetyEvents from '../pages/PlcSafety/PlcSafetyEvents';
import NewPlcSafetyEvent from '../pages/PlcSafety/NewPlcSafetyEvent';
import PlcSafetyEventDetails from '../pages/PlcSafety/PlcSafetyEventDetails';
import PlcSafetyTriggers from '../pages/PlcSafety/PlcSafetyTriggers';
import NewPlcSafetyTrigger from '../pages/PlcSafety/NewPlcSafetyTrigger';
import PlcSafetyTriggerDetails from '../pages/PlcSafety/PlcSafetyTriggerDetails';
import PlcSafetyZoneDependencies from '../pages/PlcSafety/PlcSafetyZoneDependencies';
import NewPlcSafetyZoneDependency from '../pages/PlcSafety/NewPlcSafetyZoneDependency';
import PlcResyncSecurities from '../pages/PlcSafety/PlcResyncSecurities';
// Entry Strategies
import SettingsEntryStrategies from '../pages/Settings/SettingsEntryStrategies';
import SettingsEntryStrategiesDetail from '../pages/Settings/SettingsEntryStrategiesDetails';
const authProtectedRoutes = [
  { path: '/dashboard', component: TasksDashboard },

  // Tasks
  { path: '/tasks', component: Tasks },
  { path: '/tasksWorkStations', component: TasksWorkStations },
  { path: '/newtasks', component: NewTask },
  { path: '/updateTask', component: UpdateTask },

  // Racks
  { path: '/racks', component: Racks },

  //Settings

  { path: '/settings-global', component: SettingsGlobal },
  { path: '/settings-data-retention', component: DataRetentionPolicies },
  { path: '/entry-strategies', component: SettingsEntryStrategies },
  { path: '/entry-strategy/:id', component: SettingsEntryStrategiesDetail },

  //Users
  { path: '/users', component: Users },
  { path: '/createuser', component: NewUser },
  { path: '/updateuser', component: UpdateUser },

  //Workstations
  { path: '/workstations', component: Workstations },
  { path: '/workstations-positions', component: WSPositions },
  { path: '/createworkstation', component: NewWorkstation },
  { path: '/updateworkstation', component: UpdateWorkstation },
  { path: '/profileworkstation', component: ProfileWorkstation },

  //Map
  { path: '/mapa', component: MapPositions },

  //Alerts
  { path: '/alertas', component: Alerts },


  //Parameters
  { path: '/parameters', component: Parameters },
  { path: '/createparameter', component: NewParameter },

  //DMX
  { path: '/dmxControllers', component: DmxControllers },
  { path: '/createDmxController', component: NewDmxController },
  { path: '/dmxControllerDetail/:id', component: DmxControllerDetails },
  { path: '/dmxUniverseOccupancy/:id', component: DmxUniverseOccupancy },
  { path: '/createDmxDevice', component: NewDmxDevice },
  { path: '/dmxDeviceDetail/:id', component: DmxDeviceDetails },
  { path: '/dmxDeviceProfiles', component: DmxDeviceProfiles },
  { path: '/createDmxDeviceProfile', component: NewDmxDeviceProfile },
  { path: '/dmxDeviceProfileDetail/:id', component: DmxDeviceProfileDetails },
  { path: '/plcSafetyCauses', component: PlcSafetyCauses },
  { path: '/plcSafetyEvents', component: PlcSafetyEvents },
  { path: '/createPlcSafetyEvent', component: NewPlcSafetyEvent },
  { path: '/plcSafetyEventDetail/:id', component: PlcSafetyEventDetails },
  { path: '/plcSafetyTriggers', component: PlcSafetyTriggers },
  { path: '/createPlcSafetyTrigger', component: NewPlcSafetyTrigger },
  { path: '/plcSafetyTriggerDetail/:id', component: PlcSafetyTriggerDetails },
  { path: '/plcSafetyZoneDependencies', component: PlcSafetyZoneDependencies },
  { path: '/createPlcSafetyZoneDependency', component: NewPlcSafetyZoneDependency },
  { path: '/plcResyncSecurities', component: PlcResyncSecurities },

  // this route should be at the end of all other routes
  { path: '/', exact: true, component: () => <Redirect to="/login" /> },
];

const publicRoutes = [
  { path: '/logout', component: Logout },
  { path: '/login', component: Login },
  { path: '/forgot-password', component: ForgetPwd },
  { path: '/register', component: Register },
];

export { authProtectedRoutes, publicRoutes };
